; (function ($, window, document, undefined) {
    'use strict';

    var dtDeb = $("#StartDatePicker").val(); 

    Foundation.libs.webcallback = {
        name: 'webcallback',
        version: '1.0.0',
        settings: {
            callback: function () { }
        },

        init: function (scope, method, options) {
            // initialisation à conserver
            Foundation.inherit(this, 'throttle random_str');
            this.settings = this.settings || $.extend({}, this.defaults, (options || method));
            this.bindings(method, options);
        },
        
        events: function () {
            this.initBindings();
            this.initDatepicker(dtDeb);
        },

        initBindings: function () {
            $(this.scope)
                .on('change.fndtn.webcallback', '[' + this.attr_name() + '] #select-motive', function (e) {
                    if ($('#select-motive').val() !== "") {
                        $('#commentaire-wrapper').removeClass("hide");
                        if ($('#select-motive').val() == "LOC" || $('#select-motive').val() == "ART" || $('#select-motive').val() == "ECG") {
                            $('#product-wrapper').removeClass("hide");
                        }
                        else {
                            $('#product-wrapper').addClass("hide");
                            $("#ProductReference").val('');
                        }
                    } else {
                        $('#commentaire-wrapper').addClass("hide");
                        $('#product-wrapper').addClass("hide");
                    }
                }.bind(this))
                .on('blur.fndtn.webcallback change.fndtn.webcallback keydown.fndtn.webcallback keyup.fndtn.webcallback', '[' + this.attr_name() + '] #Comment', function (e) {
                    Foundation.libs.webcallback.countCharacters($('#Comment'), $('#comment-character-length'));
                }.bind(this))
                .on('click.fndtn.webcallback', '[' + this.attr_name() + '] #radio-callback-asap', function (e) {
                    $('#creneau-wrapper').addClass("hide");
                }.bind(this))
                .on('click.fndtn.webcallback', '[' + this.attr_name() + '] #radio-choose-slot', function (e) {
                    $('#creneau-wrapper').removeClass("hide");
                }.bind(this));
        },

        countCharacters: function (input, display) {
            var maxCommentLength = 500;
            var inputValue = input.val();
            var charactersLeft = maxCommentLength - inputValue.length;

            if (charactersLeft < 0) {
                input.val(inputValue.substring(0, maxCommentLength));
                Foundation.libs.webcallback.displayCountCharacters(display, 0);
            } else {
                Foundation.libs.webcallback.displayCountCharacters(display, charactersLeft);
            }
        },

        displayCountCharacters: function (display, characterCount) {
            if (characterCount > 1) {
                display.text(characterCount + " caractères restants");
            } else {
                display.text(characterCount + " caractère restant");
            }
        },

        initDatepicker: function (dateDeb) {
            $("input#Date").datepicker({
                monthNames: ["janvier", "février", "mars", "avril", "mai", "juin",
                    "juillet", "août", "septembre", "octobre", "novembre", "décembre"
                ],
                dayNamesMin: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
                weekHeader: "Sem.",
                dateFormat: "dd/mm/yy",
                firstDay: 1,
                isRTL: false,
                showMonthAfterYear: false,
                yearSuffix: "",
                autoclose: true,
                //si les cren
                minDate: dateDeb,
                beforeShowDay: function (date) {
                    var day = date.getDay();

                    return [(day != 0 && day != 6), ''];
                },
                onSelect: function (uselessDate) {
                    var date = $(this).val();
                    Foundation.libs.webcallback.sendChosenDate(date);
                }
            });
        },

        initTimepicker: function (startMinTime, startMaxTime, endMinTime, endMaxTime) {
            $('input#StartHour').timepicker('remove');
            $('input#EndHour').timepicker('remove');

            $("input#StartHour").timepicker({
                'timeFormat': 'H:i',
                'minTime': startMinTime,
                'maxTime': startMaxTime,
                'step': '60'
            });
            $("input#EndHour").timepicker({
                'timeFormat': 'H:i',
                'minTime': endMinTime,
                'maxTime': endMaxTime,
                'step': '60'
            });
        },

        sendChosenDate: function (date) {
            $.ajax({
                url: '/WebCallback/GetOpenedSlotsFromDate',
                contentType: 'application/json',
                data: {
                    date: date
                },
                beforeSend: function (e) {
                    Foundation.libs.common.showPreloader();
                },
                complete: function (result) {

                    var json = result.responseJSON;

                    if (json.IsValid) {
                        $("input#Date").datepicker("hide");
                        $('#creneau-heure-wrapper').removeClass("hide");

                        Foundation.libs.webcallback.initTimepicker(json._StartMinTime, json._StartMaxTime, json._EndMinTime, json._EndMaxTime);
                    }
                    Foundation.libs.common.hidePreloader();                    
                },
                fail: function (err) {
                    console.log(err);
                    Foundation.libs.common.hidePreloader();
                }
            });
        }
    };
}(jQuery, this, this.document));